// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as BestRouteImport } from './routes/best'
import { Route as StorySlugRouteImport } from './routes/story.$slug'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const BestRoute = BestRouteImport.update({
            id: '/best',path: '/best',getParentRoute: () => rootRouteImport
          })
const StorySlugRoute = StorySlugRouteImport.update({
            id: '/story/$slug',path: '/story/$slug',getParentRoute: () => rootRouteImport
          })

const rootRouteChildren = {
  IndexRoute: IndexRoute,BestRoute: BestRoute,StorySlugRoute: StorySlugRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)